import {useEffect} from 'react'
import type {BannerProps} from '@primer/react'
import {useAddBanner, useDismissBanner, type InitialBanner} from '@github-ui/banner-stack'
import type {RunnerCapacityBannerPayload} from '../../routes/workflows-layout-route'

export const RUNNER_CAPACITY_BANNER_ID = 'runner-capacity-banner'

type RunnerCapacityBanner = InitialBanner & BannerProps & {'data-test-selector'?: string}

export function getRunnerCapacityBanner({message}: RunnerCapacityBannerPayload): RunnerCapacityBanner {
  return {
    id: RUNNER_CAPACITY_BANNER_ID,
    // Banner requires a title for its accessible name; hide it visually so only the message renders.
    title: 'GitHub-hosted runner capacity',
    hideTitle: true,
    description: message,
    variant: 'warning',
    'data-test-selector': RUNNER_CAPACITY_BANNER_ID,
    // Sourced from the layout-level route payload, which doesn't refetch on leaf-route soft navigation.
    persistOnNavigation: true,
  }
}

export function useRunnerCapacityBanner({data}: {data?: RunnerCapacityBannerPayload | null}) {
  const addBanner = useAddBanner()
  const dismissBanner = useDismissBanner()

  useEffect(() => {
    if (!data) return

    const id = addBanner(getRunnerCapacityBanner(data))

    return () => {
      dismissBanner(id)
    }
  }, [data, addBanner, dismissBanner])
}
